package ru.cleardocs.lkweb.pages.demo

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.cssRem
import ru.cleardocs.lkweb.api.dto.LimitDto
import ru.cleardocs.lkweb.components.widgets.rememberTimedToast
import ru.cleardocs.lkweb.plans.Plan
import ru.cleardocs.lkweb.plans.PlansList

@Composable
fun PlansDemoContent() {
    val showToast = rememberTimedToast()
    Column(
        Modifier
            .width(36.cssRem)
            .gap(1.5.cssRem),
        horizontalAlignment = Alignment.Start
    ) {
        SpanText("PlansList (фейковые тарифы)", Modifier.padding(bottom = 0.5.cssRem))

        SpanText("Полный список:", Modifier.fillMaxWidth())
        PlansList(
            plans = FakeData.plans,
            subscriptionCanceled = false,
            onPlanSelect = { showToast("Функционал в разработке") },
            onUnsubscribe = { showToast("Отписка (демо)") },
            unsubscribeLoading = false,
            unsubscribeError = null,
        )

        SpanText("Один тариф:", Modifier.fillMaxWidth().padding(top = 0.5.cssRem))
        PlansList(
            plans = listOf(
                Plan(
                    code = "trial",
                    title = "Пробный",
                    isActive = true,
                    priceRub = 0,
                    periodDays = 14,
                    limit = LimitDto(maxConnectors = 2),
                )
            ),
            subscriptionCanceled = false,
            onPlanSelect = { showToast("Функционал в разработке") },
            onUnsubscribe = { showToast("Отписка (демо)") },
            unsubscribeLoading = false,
            unsubscribeError = null,
        )

        SpanText("Пустой список:", Modifier.fillMaxWidth().padding(top = 0.5.cssRem))
        PlansList(
            plans = emptyList(),
            subscriptionCanceled = false,
            onPlanSelect = {},
            onUnsubscribe = {},
            unsubscribeLoading = false,
            unsubscribeError = null,
        )
    }
}
